import types from './types'

class Actions {
  constructor(dispatcher) {
    this.dispatcher = dispatcher;
  }

  [types.SET_TILE](data) {
    this.dispatcher.trigger(types.SET_TILE, data);
  }
}

export default Actions



// WEBPACK FOOTER //
// ./_src/riot/store/actions.js